import { IProjectDetails } from '../interfaces/project'
import { isEmpty } from 'lodash'
import Env from 'utils/env'
import { IsRHELNonContainerized } from "../utils/projectUtils";

export enum ProjectSupportPlatforms {
  openshiftOnline = 'Openshift Online'
}

export enum ProjectOperatorDistribution {
  redHatCertified = 'connect',
  marketplace = 'marketplace',
  undistributed = 'undistributed'
}

export enum ProjectOperatorPublicationMethod {
  redHatCertified = 'OpenShift In-product Catalog (Certified)',
  marketplace = 'OpenShift In-product Catalog (Red Hat Marketplace)',
  undistributed = 'Web catalog only (catalog.redhat.com)',
}

export enum ProjectDistributionMethodName {
  redHatContainerRegistry = 'rhcc',
  nonRegistry = 'non_registry',
  external = 'external',
  marketplaceOnly = 'marketplace_only',
  redhat = 'redhat'
}

export enum ContainerProjectDistributionMethod {
  rhcc = "Red Hat Container Registry",
  non_registry = 'Other Distribution Method (non-registry)',
  external = 'External Registry',
  marketplace_only = 'Red Hat Marketplace Only'
}

export enum HelmProjectDistributionMethod {
  redhat = "Helm Chart repository (charts.openshift.io)",
  external = "External helm chart repository",
  undistributed = "Web catalog only (catalog.redhat.com)"
}

export enum HelmProjectDistributionMethodName {
  redhat = 'redhat',
  external = 'external',
  undistributed = 'undistributed'
}

export const ProjectContainerKeys = {
  links: '_links',
  buildService: 'build_service',
  buildCategories: 'build_categories',
  autoPublish: 'auto_publish',
  autoRebuild: 'auto_rebuild',
  applicationCategories: 'application_categories',
  distributionApproval: 'distribution_approval',
  distributionMethod: 'distribution_method',
  dockerConfigJson: 'docker_config_json',
  githubUsernames: 'github_usernames',
  hostedRegistry: 'hosted_registry',
  isvPID: 'isv_pid',
  kubeObjects: 'kube_objects',
  osContentType: 'os_content_type',
  passedRHCert: 'passed_rhcert',
  privileged: 'privileged',
  registry: 'registry',
  registryCredentials: "registry_credentials",
  registryOverrideInstruct: 'registry_override_instruct',
  registryVendor: 'registry_vendor',
  releaseCategory: 'release_category',
  repository: 'repository',
  repositoryName: 'repository_name',
  repositoryDescription: 'repository_description',
  serviceAccountSecret: 'service_account_secret',
  supportPlatforms: 'support_platforms',
  shortDescription: 'short_description',
  sourceUri: 'source_uri',
  sourceSshPrivateKey: 'source_ssh_private_key',
  sourceRef: 'source_ref',
  sourceContextDir: 'source_context_dir',
  sourceDockerfile: 'source_dockerfile',
  type: 'type',
}

export const ProjectContainerLinks = {
  repositories: 'repositories'
}

export enum EOSContentTypes {
  OperatorBundleImage = 'Operator Bundle Image',
  UBI = 'Red Hat Universal Base Image (UBI)',
  RHEL = 'Red Hat Enterprise Linux'
}

export const ProjectDrupalKeys = {
  company_id: 'company_id',
  relation: 'relation',
  zone: 'zone'
}

export const ProjectRedhatKeys = {
  productID: 'product_id',
  productName: 'product_name',
  productVersion: 'product_version',
  productVersionID: 'product_version_id',
}

export const ProjectSelfCertification = {
  appProfiler: 'app_profiler',
  appRunsOnAppType: 'app_runs_on_app_type',
  authLogin: 'authLogin',
  certificationUrl: 'certification_url',
  commSupportOnAppType: 'comm_support_on_app_type',
  requested: 'requested',
  tsanet_member: 'tsanet_member',
}

export const ProjectKeys = {
  id: '_id',
  badges: "badges",
  certificationDate: 'certification_date',
  certificationStatus: 'certification_status',
  certificationUser: 'certification_user',
  container: 'container',
  creationDate: 'creation_date',
  drupal: 'drupal',
  helmChart: 'helm_chart',
  lastUpdateDate: 'last_update_date',
  legacyProductID: 'legacy_product_id',
  marketplace: 'marketplace',
  name: 'name',
  operatorDistribution: 'operator_distribution',
  openstack: 'openstack',
  productListings: 'product_listings',
  projectStatus: 'project_status',
  publishedBy: 'published_by',
  redhat: 'redhat',
  selfCertification: 'self_certification',
  contacts: "contacts",
  type: "type",
  allowHostedRegistry: 'hosted_registry'
}

export const ProjectContactsKeys = {
  emailAddress: 'email_address',
  type: 'type'
}

export const ProjectNonContKeys = {
  certificationStatus: "certificationStatus",
  name: "name",
  projectStatus: "projectStatus",
  rhProductName: "redhatProductName",
  rhProductVersion: "redhatProductVersion",
  type: "type",
  pyxisId: "pyxisId",
  contacts: "contacts",
}

export const ProjectHelmChartKeys = {
  distributionMethod: 'distribution_method',
  chartName: 'chart_name',
  repository: 'repository',
  distributionInstructions: 'distribution_instructions',
  publicPgpKey: 'public_pgp_key',
  githubUsernames: 'github_usernames',
  githubPullRequest: 'github_pull_request',
  shortDescription: 'short_description',
  longDescription: 'long_description',
  applicationCategories: 'application_categories'
}

export const ProjectMarketplaceKeys = {
  enablementStatus: "enablement_status",
  enablementUrl: "enablement_url",
  listingUrl: "listing_url",
  published: "published"
}

export const ProjectOpenStackKeys = {
  service: "service"
}

export enum ProjectContainerTypes {
  CONTAINER = 'container',
  OPERATOR_BUNDLE_IMAGE = 'operator bundle image',
  SCRATCH = 'scratch'
}

export enum ProjectTypes {
  Containers = 'Containers',
  RHEL = 'RHEL',
  Middleware = 'Middleware',
  HelmChart = 'Helm Chart',
  openStackInfraNonContainer = "OpenStack-infra-noncontainer",
  openStackInfraContainer = "OpenStack-infra-container",
  openStackVnf = "OpenStack-vnf",
  openStackAppContainer = "OpenStack-app-container",
  openshiftCNF = "OpenShift-cnf",
  openShiftVirtualization = "OpenShift-virtualization"
}

export enum ProjectTypesWithoutTabs {
  MIDDLEWARE_APPLICATION = 'Middleware'
}

export const catalogDistributionValues = [
  {
    name: "Red Hat Partner Connect only",
    value: "connect"
  },
  {
    name: "Red Hat Partner Connect & Marketplace",
    value: "both"
  },
  {
    name: "Red Hat Marketplace only",
    value: "marketplace"
  }
];

export const projectDisplayNames = {
  "operator": "Operator",
  "operator bundle image": "Operator Bundle Image",
  "container": "Container image",
  "scratch": "Scratch",
  "RHEL": "Red Hat Enterprise Linux Application",
  "OpenStack": "OpenStack Plugin",
  "Middleware": "Middleware Application",
  "Helm Chart": "Helm Chart",
  'OpenStack-vnf': "VNF for OpenStack",
  'OpenStack-infra-container': "OpenStack Infrastructure",
  'OpenStack-infra-noncontainer': "OpenStack Infrastructure without containers",
  'OpenStack-app-container': 'Containerized application for OpenStack',
  [ProjectTypes.openshiftCNF]: 'Cloud-native Network Function (CNF)',
  [ProjectTypes.openShiftVirtualization]: 'Openshift Virtualization'
}

export const zoneTypeMapping = {
  "Containers": ["container", "operator bundle image", "scratch"]
}

export type TGetProjectTypeDataReturnType = ProjectContainerTypes.CONTAINER | ProjectContainerTypes.OPERATOR_BUNDLE_IMAGE |
  ProjectContainerTypes.SCRATCH | ProjectTypes.RHEL | ProjectTypes.Middleware |
  ProjectTypes.HelmChart | ProjectTypes.openStackInfraNonContainer | ProjectTypes.openStackInfraContainer |
  ProjectTypes.openStackVnf | ProjectTypes.openStackAppContainer | ProjectTypes.openshiftCNF | "RHEL-NonContainer" |
  ProjectTypes.openShiftVirtualization | ProjectTypesWithoutTabs.MIDDLEWARE_APPLICATION;
// if project.type = Containers then return Project type as container.type in form of object
// having text and value properties like projectTypesNames
export const getProjectTypeData = (data: IProjectDetails, includeRhelNc = false): TGetProjectTypeDataReturnType => {
  let type: TGetProjectTypeDataReturnType;
  if (!isEmpty(data)) {
    switch (data[ProjectKeys.type]) {
      case 'Containers': {
        type = zoneTypeMapping['Containers'].find(el => (el === data[ProjectKeys.container][ProjectContainerKeys.type])) as TGetProjectTypeDataReturnType;
        break;
      }
      default: {
        if (includeRhelNc && IsRHELNonContainerized(data)) {
          type = 'RHEL-NonContainer'
        } else {
          type = data[ProjectKeys.type] as TGetProjectTypeDataReturnType;
        }
        break;
      }
    }
  }
  return type;
}

export const ProjectTypeMapper = {
  container: "container",
  OpenStack: "OpenStack",
  RHEL: "RHEL"
}

export const projectErrorMessages = {
  500: {
    title: 'Internal Server Error',
    description: 'We encountered an error and are working to resolve it.',
    shortDescription: 'Try accessing this page again later.',
    errorCode: 500,
    suggestionLinks: [
      {
        text: 'Manage Products',
        link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/products`
      },
      {
        text: 'Manage Projects',
        link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/projects`
      }
    ]
  },
  400: {
    title: 'Bad Request',
    description: 'An error occured while fetching project details.',
    shortDescription: null,
    errorCode: 400,
    suggestionLinks: [
      {
        text: 'Manage Products',
        link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/products`
      },
      {
        text: 'Manage Projects',
        link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/projects`
      }
    ]
  },
  401: {
    title: 'Unauthorized',
    description: 'Session has been ended. You should login again.',
    shortDescription: null,
    errorCode: 401,
    suggestionLinks: [
      {
        text: 'Manage Products',
        link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/products`
      },
      {
        text: 'Manage Projects',
        link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/projects`
      }
    ]
  },
  403: {
    title: 'Forbidden',
    description: 'Looks like there is a permission issue.',
    shortDescription: null,
    errorCode: 403,
    suggestionLinks: [
      {
        text: 'Manage Products',
        link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/products`
      },
      {
        text: 'Manage Projects',
        link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/projects`
      }
    ]
  },
  404: {
    title: 'Project not found',
    description: 'The project details you’re looking for are not found.',
    shortDescription: 'The good news is that we can help.',
    errorCode: 404,
    suggestionLinks: [
      {
        text: 'Manage Products',
        link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/products`
      },
      {
        text: 'Manage Projects',
        link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/projects`
      }
    ]
  },
  default: {
    title: null,
    description: 'We are facing some issues while fetching project details. Please try again in sometime',
    shortDescription: null,
    errorCode: null,
    suggestionLinks: [
      {
        text: 'Manage Products',
        link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/products`
      },
      {
        text: 'Manage Projects',
        link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/projects`
      }
    ]
  },
}

export const SystemStatus = {
  major_outage: 'Major Outage',
  partial_outage: 'Partial Outage',
  operational: 'Operational',
  degraded_performance: 'Degraded Performance',
  under_maintenance: 'Under Maintenance'
}

export const SystemStatusAlertVariant = {
  major_outage: 'danger',
  partial_outage: 'warning',
  operational: 'success',
  degraded_performance: 'warning',
  under_maintenance: 'warning',
  scheduled: 'info',
  in_progress: 'info',
  investigating: 'info',
  identified: 'info',
  monitoring: 'info',
  resolved: 'success',
  verifying: 'info',
  completed: 'success'
}

export enum ProjectCertificationStatus {
  started = 'Started',
  certificationChecklistInProgress = 'Certification Checklist In Progress',
  certificationCompleted = 'Certification Completed',
  certificationTestsInProgress = 'Certification Tests In Progress',
  inProgress = 'In Progress',
  published = 'Published',
  readyForCertification = 'Ready For Certification',
  unpublished = 'Unpublished',
  waitingForContainerImage = 'Waiting for Container Image'
}

export enum ProjectMarketplaceStatus {
  ELIGIBLE = 'eligible',
  REQUESTED = 'requested',
  APPROVED = 'approved',
  DENIED = 'denied',
  INELIGIBLE = 'ineligible'
}
